export const getSystemThemeMode = () => {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
};
